<template>
  <ModalSlot
    ref="sdzModal"
    @close="onClose"
    @clickOutside="onClose"
    :title="getTitle"
    :width="getModalSize"
    custom-class="verify-account__in_progress"
    theme="light"
    z-index="999999"
    hide-confirm-button
    hide-cancel-button
    close-icon
  >
    <div class="verify-account__container">
      <p>A sua conta está sendo analisada e em até 48 horas a verificação será concluída.</p>

      <div class="va-actions">
        <button
          @click="abrirZendesk"
          class="v-btn btn-link "
        >
          Falar com suporte
        </button>
        <v-btn
          @click="onClose"
          class="white--text v-btn theme--light primary"
        >
          Ok, entendi
        </v-btn>
      </div>
    </div>
  </ModalSlot>
</template>

<script>
import ModalSlot from '@/components/sdz/SdzModal.vue'
import { ACCOUNT_STATUS, ACCOUNT_STATUS_TITLE } from '@/helpers/verified-account'
export default {
  name: 'VerifyAccountInProgress',
  components: {
    ModalSlot,

  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    verifyStep: 1,
    isLoading: false,
    qRCodeUrl: '',
    hasError: false
  }),
  mounted() {
    if (this.show) {
      this.$refs.sdzModal.open()
    }
  },
  computed: {
    getTitle() {
      return ACCOUNT_STATUS_TITLE[ACCOUNT_STATUS.inProgress]
    },
    getModalSize() {
      if (this.$isMobile()) return 'auto'
      return '360'
    }
  },
  methods: {
    abrirZendesk() {
      this.onClose()
      window.zE('messenger', 'open')
  },

    onClose() {
      this.$emit('close')
    },
  }
}
</script>

<style lang="stylus" scoped>
.verify-account__in_progress
  width auto

  .verify-account__container
    padding 16px 16px 0
    margin 8px 0
    width 360px

    p
      line-height 24px

    .va-actions
      margin-top 32px
      width 100%
      display flex
      justify-content space-between
      align-items center

@media(max-width: 959px)
  .verify-account__in_progress
    .verify-account__container
      width auto
</style>
